/*
 * 韩语
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PresellPrivacyCollect/kr/authorization.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * 韩国
 */
import React, { memo } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

const HTML_CONTENT = `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">고객님의 예약 주문이 매장에 도착했음을 알려드리고, 수령 시 예약 주문을 확인하기 위해 저희는 고객님의 성함과 이메일 주소를 수집하여 제3자인 당사의 협력업체와 공유합니다. 해당 협력업체는 고객님의 이메일 주소로 발송될 수령 코드를 생성하기 위해 저희를 대신하여 이를 처리합니다.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">고객님과의 계약을 이행하기 위해 반드시 필요한 경우에만 개인정보를 처리하며, 이것이 개인정보 처리의 법적인 근거가 됩니다.</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">위 목적을 위해, 저희는 고객님의 개인정보를 다음의 제3자에게 이전할 수 있습니다.</span>
                </p>
                <table border="1" cellpadding="5" cellspacing="0" style="border-collapse:collapse; width:100%; margin-top:12pt; margin-bottom:12pt; font-family:Arial; font-size:8pt;">
                    <thead>
                        <tr style="background-color:#f5f5f5;">
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:5%;">순번</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:18%;">제공받는 자</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:15%;">제공되는 개인정보 항목</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:20%;">제공받는 자의 이용 목적</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:22%;">제공받는 자의 보유 및 이용 기간</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:20%;">개인정보 보호정책</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="border:1px solid #000; padding:5px; text-align:center;">1</td>
                            <td style="border:1px solid #000; padding:5px;">샤오미테크놀로지 코리아 유한책임 회사</td>
                            <td style="border:1px solid #000; padding:5px;">성명 및 전자우편 주소</td>
                            <td style="border:1px solid #000; padding:5px;">전자우편 주소로 전송될 픽업 코드를 생성하기 위함</td>
                            <td style="border:1px solid #000; padding:5px;">적용 법률에서 달리 기재되어 있는 경우를 제외하고, 수집 및 이용 목적이 달성될까지</td>
                            <td style="border:1px solid #000; padding:5px; word-wrap:break-word; word-break:break-word;">샤오미의 개인정보 보호정책은 <a href="https://privacy.mi.com/all/languages" style="text-decoration:none; color:#3370ff; word-break:break-all;">https://privacy.mi.com/all/languages</a> 에서 확인 할 수 있음</td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%; padding:8px;">
                    <span style="font-family:Arial">개인정보 처리 방식이나 고객님의 데이터 보호 권리(예: 열람, 정정, 및/또는 삭제) 행사 방법에 대하여 궁금한 점이 있으시면 매장 직원에게 문의하시기 바랍니다.</span>
                </p>
            </div>
        </body>
    </html>`;

function ProtocolPage() {
    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)